import type { MultiSelectOption } from '@rtkwlf/fenrir-react';
import type { i18n } from 'i18next';
import type { QueryParamConfig } from 'use-query-params';

import { LabelLookupMultiSelectOptionParam } from '../label-lookup-multi-select-option-param/label-lookup-multi-select-option-param';

export const LocationMultiSelectOptionParam = (
  i18n: i18n,
): QueryParamConfig<MultiSelectOption[] | undefined> => {
  const countries = i18n.getDataByLanguage(i18n.language)?.countries || {};

  return LabelLookupMultiSelectOptionParam(countries);
};
